import { combineReducers } from 'redux';
import { reducer as comparison } from './comparison';
import { reducer as drilldown } from './drilldown';
import { reducer as meta } from './meta';


export default combineReducers({
  comparison,
  drilldown,
  meta,
});
